module.exports = __webpack_public_path__ + "static/img/cha-bg.1cc7cc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cha/cha-bg.png
// module id = G7iB
// module chunks = 1